import type { IOffers } from '../api/HandRequest.interface';

export enum DiscountStatus {
  BEST = 'best',
  ACCEPT = 'accept',
  BAD = 'bad',
  ONLY = 'only',
  STATIC = 'static',
}

export function getDiscountStatusFn(
  discount: number,
  offers: IOffers | undefined,
): DiscountStatus {
  if (!offers || offers.countSuppliers === 0) {
    return DiscountStatus.ONLY;
  }
  if (offers.min === offers.max) {
    return DiscountStatus.ACCEPT;
  }
  if (discount <= offers?.min) {
    return DiscountStatus.BAD;
  }
  if (discount >= offers.max) {
    return DiscountStatus.BEST;
  }
  if (discount > offers.min && discount < offers.max) {
    return DiscountStatus.ACCEPT;
  }
  return DiscountStatus.STATIC;
}
